import { render, staticRenderFns } from "./ProductHarvests2.vue?vue&type=template&id=0de1db02&scoped=true&"
import script from "./ProductHarvests2.vue?vue&type=script&lang=js&"
export * from "./ProductHarvests2.vue?vue&type=script&lang=js&"
import style0 from "./ProductHarvests2.vue?vue&type=style&index=0&id=0de1db02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de1db02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VDivider,VSelect})
